

















import {Component, Prop, Vue} from "vue-property-decorator";
import {PartnerStore} from "@/modules/partners/store";
import {Partner} from "@/interfaces/entity";

@Component({
    name: "PartnerTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly partnerId!: string;

    get partner(): Partner {
        return PartnerStore.data[this.partnerId];
    }

    set partner(value: Partner) {
        PartnerStore.data[this.partnerId] = value;
    }
    async onConfirm() {
        try {
            await PartnerStore.deletePartner(this.partnerId);
            this.$message.success({
                content: "Xóa đối tác thành công"
            });
        } catch (e) {
            console.log(e);
            this.$message.error({
                content: "Xóa đối thất bại"
            });
        }
    }
}
